var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMalt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 433 433",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m358.1 152.5l-204.8 204.8c-21.7 21.7-54.6 44.4-88.7 10.3-34.2-34.1-11.5-67.1 10.2-88.8l204.8-204.8c21.7-21.6 56.3-42.6 88.8-10.2 32.4 32.4 11.4 67.1-10.3 88.7zm-195.3-106.2c4.5-23.3 17.8-44.5 53.2-44.5 35.4 0 48.7 21.1 53.3 44.4-3.1 2.6-6.1 5.4-9.1 8.4l-44.1 44.2-43.4-43.4c-3.3-3.3-6.6-6.2-9.9-9.1zm106.4 339.4c-4.9 23.8-19 45.7-53.2 45.7-34.1 0-48.1-21.7-53.1-45.5 3.3-2.8 6.5-5.9 9.8-9.2l43.4-43.3 44.1 44.1c3 3 6 5.6 9 8.2zm-222.7-116.5c-23.9-4.9-45.8-18.9-45.8-53.2 0-45.8 39.3-55.5 70-55.5h83.6c0 0-105 105.5-107.8 108.7zm383.8-53.2c0 48.3-39.3 55.6-70 55.6h-82.4c0 0 105.3-105.8 107.9-108.8 23.4 4.6 44.5 17.9 44.5 53.2zm-372-82.3c-13.2-19.7-18.8-44.1 6.2-69.1 34.2-34.2 67.1-11.5 88.8 10.2l43.3 43.4-14.9 14.9c0 0-119.3 0.3-123.4 0.6zm315.3 164.7c13.4 20.3 18.9 45.8-5.3 70-32.4 32.4-67 11.4-88.7-10.3l-44.2-44.1 15-15c0 0 118.9-0.3 123.2-0.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalt);
export default __webpack_public_path__ + "static/media/malt.e1919b13590738b8dee8a0a0abd4b055.svg";
export { ForwardRef as ReactComponent };